import React, { useState, useContext } from "react";
import axios from "axios";
import UserService from "../../services/UserService";
import {
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    ListItemText,
    Slide,
} from "@mui/material";
import Button from "components/CustomButtons/Button";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem";
import GridContainer from "components/Grid/GridContainer";
import { AddCircleOutline } from "@mui/icons-material";
import List from "@mui/material/List";
import uuid from "react-uuid";
import { makeStyles } from "@mui/styles";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";
import LineCondition from "components/Search/LineCondition";
import CustomDialogTitle from "../Dialog/CustomDialogTitle";
import AdvancedSearchResult from "./AdvancedSearchResult";
import CustomSelect from "components/Input/CustomSelect.js";
import { postAdvancedSearch } from "services/ConfigServices.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ReactLoading from "react-loading";
import { width } from "@mui/system";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});


const searchStyle = makeStyles(advancedSearchStyle);

function AdvancedSearch(props) {
    const appContext = useContext(AdvancedSearchContext);
    const { chartIdGroup, groupInfoListById } = appContext;
    const { open, handleHideAdvancedSearch, handleCloseSearch, getAdvancedResultTree } = props;
    const conditionAnd = 'Et';
    const conditionOr = 'Ou';
    const [openModalResult, setOpenModalResult] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [filters, setFilters] = useState({ or: [], and: [] });
    const [type, setType] = useState('1.0');
    const [searchInProgress, setSearchInProgress] = useState(false);

    const addingAndCondition = () => {
        const id = uuid();
        const obj = {
            "item": "",
            "comparator": 'text_startswith',
            "value": '',
            "id": id,
        };
        let newFilters = { ...filters };
        newFilters.and.push(obj);
        setFilters(newFilters);
    }

    const removeAndCondition = (id) => {
        let newFilters = { ...filters };
        const remove = newFilters.and;
        remove.find((o, i) => {
            if (o.id === id) {
                remove.splice(i, 1);
                return true;
            }
            return false;
        });
        newFilters.and = remove;
        setFilters(newFilters);
    }

    const addingOrCondition = () => {
        const id = uuid();
        const obj = {
            "item": "",
            "comparator": 'text_startswith',
            "value": '',
            "id": id,
        };
        let newFilters = { ...filters };
        newFilters.or.push(obj);
        setFilters(newFilters);
    }

    const removeOrCondition = (id) => {
        let newFilters = { ...filters };
        const remove = newFilters.or;
        remove.find((o, i) => {
            if (o.id === id) {
                remove.splice(i, 1);
                return true;
            }
            return false;
        });
        newFilters.or = remove;
        setFilters(newFilters);
    }

    const handleConditionChange = () => {
        let newFilters = { ...filters };
        setFilters(newFilters);
    }

    const handleHideAllModal = () => {
        setOpenModalResult(false);
        setFilters({ or: [], and: [] });
        handleHideAdvancedSearch();
    };

    const handleHideSearchResult = () => {
        setOpenModalResult(false);
    };

    const handleSearchResult = () => {
        setOpenModalResult(true);
    }

    const handleHideAdvancedSearchResult = () => {
        setOpenModalResult(false);
        
        getAdvancedResultTree();
    };

    const submitAdvancedSearch = async () => {
        setSearchInProgress(true);
        await axios.post(postAdvancedSearch(chartIdGroup),
            {
                andconditions: filters.and,
                orconditions: filters.or,
                type: type,
            },
            {
                headers: {
                    Authorization: `Bearer ${UserService.getToken()}`,
                    "Content-Type": "application/json; charset=utf-8",
                }
            }
        ).then(response => {
            if (response.status === 200) {
                let result;
                result = response.data;
                handleSearchResult();
                setSearchInProgress(false);
                setSearchResult(result);
            }
        }).catch(error => {
            console.error('error', error);
            setSearchInProgress(false);
        })
    }

    const handleTypeChange = (event) => {
        setType(event.target.value);
    };

    const typedata = [
        { name: "Site", id: "1.0" },
        { name: "Bâtiment", id: "2.0" },
        { name: "Zone", id: "3.0" },
        { name: "Equipement urbain", id: "2.1" },
        { name: "Commune", id: "0.0" },
        { name: "EPCI", id: "0.1" },
        { name: "Groupe", id: "0.2" },
    ];

    const classes = searchStyle();
    return (
        <div>
            <Dialog
                scroll={'body'}
                open={open}
                classes={{
                    root: classes.center,
                    paper: classes.modal
                }}
                fullWidth={true}
                maxWidth={'md'}
                transition={Transition}
                keepMounted
                onClose={handleHideAllModal}
                aria-labelledby="Recherche avancée"
                aria-describedby="effectuer une recherche avancée"
            >
                <CustomDialogTitle disableTypography onClose={handleHideAllModal} aria-label="Close modal">
                    Recherche avancée
                </CustomDialogTitle>

                <DialogContent dividers className={classes.modalBody}>
                    <GridContainer>
                        <GridContainer style={{width:'100%'}}>
                            <GridItem xs={12} sm={12}>
                                <CustomSelect
                                    inputTitle={'Type de groupe'}
                                    selectValue={type}
                                    handleSelectValueChange={handleTypeChange}
                                    data={typedata}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridItem xs={12} sm={12}>
                            <List component={"nav"}>
                                <ListItemText className={classes.listItemText}> Les groupes doivent remplir toutes ces conditions </ListItemText>

                                {
                                    filters?.and?.map((condition) => {
                                        return (
                                            <LineCondition
                                                key={condition.id} id={condition.id} obj={condition}
                                                removeCondition={() => removeAndCondition(condition.id)}
                                                whichCondition={conditionAnd}
                                                handleConditionChange={handleConditionChange}
                                                type={type}
                                            ></LineCondition>
                                        );
                                    })
                                }
                            </List>

                            <FormControlLabel
                                value="addCondition"
                                className={classes.formControlLabel}
                                control={
                                    <Button
                                        type="button" round
                                        color="transparent"
                                        justIcon size={"sm"}
                                        onClick={addingAndCondition}
                                    >
                                        <AddCircleOutline> </AddCircleOutline>
                                    </Button>
                                }
                                label=" Ajouter une condition "
                            />
                        </GridItem>
                    </GridContainer>

                    <GridContainer>
                        <GridItem xs={12} sm={12}>
                            <List component={"nav"}>
                                <ListItemText className={classes.listItemText}> Les groupes doivent remplir au moins une condition </ListItemText>
                                {
                                    filters?.or?.map((condition) => {
                                        return (
                                            <LineCondition
                                                key={condition.id} id={condition.id} obj={condition}
                                                removeCondition={() => removeOrCondition(condition.id)}
                                                whichCondition={conditionOr}
                                                handleConditionChange={handleConditionChange}
                                                type={type}
                                            ></LineCondition>
                                        );
                                    })
                                }
                            </List>
                            <FormControlLabel
                                value="addCondition"
                                className={classes.formControlLabel}
                                control={
                                    <Button type="button" round color="transparent" justIcon size={"sm"}
                                        onClick={addingOrCondition}
                                    >
                                        <AddCircleOutline> </AddCircleOutline>
                                    </Button>
                                }
                                label=" Ajouter une condition"
                            />
                        </GridItem>
                    </GridContainer>
                </DialogContent>

                <DialogActions
                    className={classes.modalFooter + classes.modalFooterCenter}
                >
                    {searchInProgress ?
                        <Button type="button" color={'success'}
                            disabled
                            className={classes.buttonsModal}
                        >
                          Recherche en cours...
                        </Button>
                        :
                        <Button type="button" color={'success'}
                            onClick={submitAdvancedSearch}
                            className={classes.buttonsModal}
                        >
                            Rechercher
                        </Button>

                    }
                </DialogActions>

                <AdvancedSearchResult
                    open={openModalResult}
                    handleHideSearchResult={handleHideSearchResult}
                    searchResult={searchResult}
                    handleHideAllModal={handleHideAdvancedSearchResult}
                >
                </AdvancedSearchResult>
            </Dialog>
        </div >
    );

}
export default AdvancedSearch;

AdvancedSearch.propTypes = {
    open: PropTypes.bool,
    handleHideAdvancedSearch: PropTypes.func,
    handleHideAllModal: PropTypes.func,
    getAdvancedResultTree: PropTypes.func,
}